import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import ArgonBox from "components/ArgonBox";

const headerSkeletonSx = { bgcolor: "rgba(255,255,255,0.22)" };

function StatCardSkeleton() {
  return (
    <Card sx={{ height: "100%" }}>
      <ArgonBox p={2}>
        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Skeleton variant="text" width="72%" height={22} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="48%" height={34} />
          </Grid>
          <Grid item>
            <Skeleton variant="rounded" width={48} height={48} sx={{ borderRadius: "0.75rem" }} />
          </Grid>
        </Grid>
      </ArgonBox>
    </Card>
  );
}

function DashboardSkeleton() {
  return (
    <ArgonBox py={1} sx={{ overflowX: "hidden", boxSizing: "border-box", maxWidth: "100vw" }}>
      <ArgonBox mb={4} position="relative" zIndex={1}>
        <Skeleton variant="text" width={{ xs: "85%", sm: 360 }} height={44} sx={headerSkeletonSx} />
        <Skeleton
          variant="text"
          width={{ xs: "70%", sm: 280 }}
          height={28}
          sx={{ mt: 1, ...headerSkeletonSx, bgcolor: "rgba(255,255,255,0.16)" }}
        />
      </ArgonBox>
      <Grid container spacing={3}>
        {[0, 1, 2, 3].map((i) => (
          <Grid item xs={12} md={6} lg={3} key={i}>
            <StatCardSkeleton />
          </Grid>
        ))}
      </Grid>
      <ArgonBox mt={3}>
        <Card>
          <ArgonBox p={2}>
            <Skeleton variant="text" width={140} height={32} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="100%" height={400} />
          </ArgonBox>
        </Card>
      </ArgonBox>
    </ArgonBox>
  );
}

export default DashboardSkeleton;
